export const environment = {
    URL: window.location.hostname == "localhost" ? "http://54.246.140.83:8088" : `${window.location.protocol + '//' + window.location.hostname}` ,
    FrontURL: window.location.protocol + '//' + window.location.hostname,
};
// export const environment = {
//     URL: window.location.hostname == "localhost" ? "http://localhost:8088" : "http://54.246.140.83:8088" ,
//     FrontURL: window.location.protocol + '//' + window.location.hostname,
// };
// export const environment = {
//     URL: window.location.protocol + '//' + window.location.hostname,
// };
